<app-navbar title="Transporty"></app-navbar>

<app-dynamic-table
	module="transports"
	[elements]="data"
	[tableRows]="tableRows"
	[haveFilters]="false"
></app-dynamic-table>
